import {Component, Inject, InjectionToken, OnInit, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, NavigationEnd,ActivatedRoute, NavigationStart } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { NavigationEvent } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ExternalRouterService } from './services/external-router.service';
import {environment as env} from 'src/environments/environment'
import {APIConstants} from './app.constants'
import { LoginNameService } from './services/login-name.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AppComponent implements OnInit{
  title = 'onelap';
  loading = false;
  
  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private meta:Meta,
              @Inject(PLATFORM_ID) private _platform:Object,
              private extRouterService:ExternalRouterService,
            
              ) {
       
                
  }
  
  ngOnInit() {
   
    // this.router.events.pipe(
    //     filter(event => event instanceof NavigationEnd),
    //     map(() => {this.router
    //       let child = this.activatedRoute.firstChild;
    //       console.log(child)
    //       // while (child.firstChild) {
    //       //   child = child.firstChild;
    //       // }
    //       return child.snapshot.data;
    //     })
    //   )
    //   .subscribe((data: any) => {
    //     // console.log("url is",this.activatedRoute.url)
    //     // var rt = this.getChild(this.activatedRoute)
    //     // console.log("activated",rt.data);
    //     // rt.data.subscribe(data => {
    //       this.titleService.setTitle(data['title'])
    //       this.meta.updateTag({name:'description',content: data['description']})
    //     // });
    //   })
    
 
  }
   
 
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  hideZohoChat() {
    if ((<any>window).$zoho && (<any>window).$zoho.salesiq) {
      (<any>window).$zoho.salesiq.floatwindow.visible("hide");
      // console.log("Zoho chat window hidden");
    }
  }

}
